module.exports = __webpack_public_path__ + "img/Uso de quebra vento em pomar de maçã 2.d8be7309.webp";